import axios from "../axios"
import { AxiosResponse } from "axios"

export function queryExceptions(params: {}): Promise<AxiosResponse<any>> {
    return axios.get(`/exceptions`, {
        params: params
    })
}
export function queryPublishedExceptions(projectId: number, params: {}): Promise<AxiosResponse<any>> {
    return axios.get(`/projects/${projectId}/exceptions`, {
        params: params
    })
}

export function publishException(exceptionId: number, params: {}): Promise<AxiosResponse<any>> {
    return axios.post(`/exceptions/${exceptionId}/publish`, null, {
        params: params
    })
}